import axios from "axios";
import { SECURITY_END_POINT, FUNCTION_END_POINT, NODE_MODEL_ACCESS_END_POINT } from "../../../api/endpoints";

async function getUserByUid(userUID, jwtToken) {
  return await axios
    .get(SECURITY_END_POINT + "UserByUid/" + userUID + "/", {
      headers: {
        Authorization: "Bearer " + jwtToken,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;
        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            error: error.response.data.message,
            message: error.response.data.message,
            code: error.response.status,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        error: "Unable to fetch user information",
        message: "Unable to fetch user information",
        code: 500,
        messageCode: 2,
      };
    });
}

async function getUserFullDetails(jwtToken, userloginDetail) {
  return await axios
    .post(SECURITY_END_POINT + "Authenticate", userloginDetail, {
      headers: {
        Authorization: "Bearer " + jwtToken,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;
        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            error: error.response.data.message,
            message: error.response.data.message,
            code: error.response.status,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        error: "Unable to fetch user information",
        message: "Unable to fetch user information",
        code: 500,
        messageCode: 2,
      };
    });
}

async function getUserToken(userloginDetail) {
  return await axios
    .post(SECURITY_END_POINT + "Token/authenticate", userloginDetail)
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;

        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            error: error.response.data.message,
            message: error.response.data.message,
            code: error.response.status,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        error: "Token Authentication Failed",
        message: "Token Authentication Failed",
        code: 500,
        messageCode: 2,
      };
    });
}


async function newUserToken(userDetails){
  return await axios
  .post(NODE_MODEL_ACCESS_END_POINT + "api-view/auth/login", userDetails, {
    headers: {
      "Content-Type": "application/json",
    },
  })
  .then((res) => {
    if (res.status === 200) {
      var response = res.data;
      return {
        status: true,
        response,
      };
    }
  })
  .catch(function (error) {
    try {
      if (error?.response?.status === 400) {
        return {
          status: false, 
          code: error.response.status,
          message: error.response.data.message,
          messageCode: 1,
        };
      }
    } catch {}
    return {
      status: false,
      code: 500,
      message: "Token Generation Failed",
      messageCode: 2,
    };
  });
}


async function getUserTokenJWT(userloginDetail, jwtToken) {
  return await axios
    .post(SECURITY_END_POINT + "Token/authenticate", userloginDetail, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwtToken,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;
        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            code: error.response.status,
            message: error.response.data.message,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        code: 500,
        message: "Token Authentication Failed",
        messageCode: 2,
      };
    });
}

async function userRegistration(userData, jwtToken) {
  return await axios
    .post(SECURITY_END_POINT + "User", userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwtToken,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;
        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            code: error.response.status,
            message: error.response.data.message,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        code: 500,
        message: "User Registration Failed",
        messageCode: 2,
      };
    });
}

async function getUserPasswordToken(userloginDetail, jwtToken) {
  return await axios
    .post(SECURITY_END_POINT + "/Users/PasswordResetToken", userloginDetail, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwtToken,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;

        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            error: error.response.data.message,
            message: error.response.data.message,
            code: error.response.status,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        error: "Token Authentication Failed",
        message: "Token Authentication Failed",
        code: 500,
        messageCode: 2,
      };
    });
}

async function passwordResetMail(userData, jwtToken) {
  return await axios
    .post(
      SECURITY_END_POINT + "/SendPasswordResetMail",
      { ...userData, appName: "Certification" },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + jwtToken,
        },
      }
    )
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;
        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            code: error.response.status,
            message: error.response.data.message,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        code: 500,
        message: "User Send Password Reset Mail Failed",
        messageCode: 2,
      };
    });
}

async function changeUserPassword(user, jwtToken) {
  return await axios
    .put(SECURITY_END_POINT + "/UserUpdate/", user, {
      headers: { Authorization: "Bearer " + jwtToken },
    })
    .then((res) => {
      if (res.status === 200) {
        return {
          status: true,
          code: 200,
          title: "Request is sent",
          message:
            "Changing Password Request is sent to admin, you will be notified soon",
          messageCode: 10,
        };
      } else {
        return {
          status: false,
          title: "Request sent Failed",
          message: "Unable to Sent Request For Changing Password",
          messageCode: 11,
          code: res.status,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            title: "Request sent Failed",
            messageCode: 21,
            code: error.response.status,
            message: error.response.data.message,
          };
        }
      } catch {}
      return {
        status: false,
        title: "Request sent Failed",
        messageCode: 22,
        code: 500,
        message: "Unable to Sent Request For Changing Password",
      };
    });
}

async function userApproval(userData, jwtToken) {
  return await axios
    .post(SECURITY_END_POINT + "User", userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwtToken,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;
        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            code: error.response.status,
            message: error.response.data.message,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        code: 500,
        message: "User Registration Failed",
        messageCode: 2,
      };
    });
}

async function updateUser(userData, jwtToken) {
  return await axios
    .put(SECURITY_END_POINT + "UserUpdate", userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwtToken,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        var response = res.data;
        return {
          status: true,
          response,
        };
      }
    })
    .catch(function (error) {
      try {
        if (error?.response?.status === 400) {
          return {
            status: false,
            code: error.response.status,
            message: error.response.data.message,
            messageCode: 1,
          };
        }
      } catch {}
      return {
        status: false,
        code: 500,
        message: "User Registration Failed",
        messageCode: 2,
      };
    });
}

export {
  getUserByUid,
  getUserFullDetails,
  getUserToken,
  getUserTokenJWT,
  userRegistration,
  getUserPasswordToken,
  passwordResetMail,
  userApproval,
  changeUserPassword,
  updateUser,
  newUserToken
};
